<!--
    父组件使用方式
        <hxlPagin :queryParams="queryParams" @changePage="changePage"/>

        import hxlPagin from "@/components/hxlPagin";
        components:{hxlPagin},
        
        queryParams: {
            pageNum: 1,
            pageSize: 3,
            total: 0,
            memberNumber: '',   //会员编号
            time: ''            //时间筛选
        },

        changePage (e) { this.queryParams.pageNum = e; this.getList(); },
-->


<template>
    <div class="pagin">
        <!-- <el-pagination :hide-on-single-page="true" -->
        <el-pagination 
                       layout="prev, pager, next"
                       background
                       style="padding-top:20px;text-align:right"
                       :page-size="queryParams.pageSize"
                       :total="queryParams.total"
                       @current-change="changePage" />

    </div>
</template>

<script>
export default {
    props:['queryParams','lotteryType','teacherType'],
    methods:{
        changePage (e) {


			if(this.lotteryType){
				this.$emit('changePage',{pageNum:e,lotteryType:this.lotteryType})
			}else if(this.teacherType){
                this.$emit('changePage',{pageNum:e,teacherType:this.teacherType})
            } else{
				this.$emit('changePage',e)
			}
            
        },
    }
}
</script>
